import { ObjectType } from "features/types";

const createImageObjects = (data: any) => {
  let image = {};
  let updatedImage = {};
  const prop = `image`;
  if (data[prop]) {
    if (data[prop].file) {
      image = data[prop].file;
      updatedImage = {
        index: 0,
        name: data[prop].file.name,
        is_main_image: data[prop].is_main_image,
      };
    } else if (data[prop].image === undefined) {
      updatedImage = {
        index: 0,
        name: undefined,
        is_main_image: data[prop].is_main_image,
      };
    }
  }

  return { image, updatedImage };
};

export const createAccessoryObj = (data: any) => {
  let { image, updatedImage } = createImageObjects(data);
  return {
    image,
    updatedImage,
    brand: data.brand,
    title: data.title,
    price: data.price,
    price_eur: data.price_eur,
    price_promotion: data.price_promotion,
    price_promotion_eur: data.price_promotion_eur,
    quantity: data.quantity,
    description: data.description,
    objectType: ObjectType.accessory,
    titleMeta: data.titleMeta,
    tagsMeta: data.tagsMeta,
    descriptionMeta: data.descriptionMeta,
    alias: data.alias,
  };
};
